module.exports = __webpack_public_path__ + "static/media/first-publish-explain.e3de96d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/first-publish-explain.png
// module id = 1152
// module chunks = 110